
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { UserCheck, GraduationCap, Users, RefreshCw } from 'lucide-react';
import { useAccountApprovals } from '@/hooks/useAccountApprovals';
import { UserApprovalTable } from './UserApprovalTable';

export const AccountApprovalsSection = () => {
  const {
    pendingLecturers,
    pendingStudents,
    loading,
    actionLoading,
    handleApprove,
    handleReject,
    refreshData
  } = useAccountApprovals();

  return (
    <Card className="border-border/70 bg-card/80">
      <CardHeader className="px-4 sm:px-6">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <CardTitle className="text-muted-foreground flex items-center gap-2">
            <UserCheck className="h-5 w-5" />
            Հաշիվների հաստատում
          </CardTitle>
          <Button
            onClick={refreshData}
            variant="outline"
            size="sm"
            disabled={loading}
            className="min-h-11 w-full sm:w-auto"
          >
            <RefreshCw className={`h-4 w-4 mr-2 ${loading ? 'animate-spin' : ''}`} />
            Թարմացնել
          </Button>
        </div>
      </CardHeader>
      <CardContent className="px-4 sm:px-6">
        {loading ? (
          <div className="text-center py-8 text-muted-foreground">
            <RefreshCw className="h-6 w-6 mx-auto mb-2 animate-spin" />
            Բեռնվում է...
          </div>
        ) : (
          <Tabs defaultValue="students" className="w-full">
            <div className="-mx-1 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
            <TabsList className="inline-flex h-auto min-w-max gap-1 border border-border/70 bg-muted/70 p-1.5 sm:grid sm:w-full sm:min-w-0 sm:grid-cols-2">
              <TabsTrigger 
                value="students"
                className="min-h-11 shrink-0 rounded-md px-3 text-xs text-muted-foreground data-[state=active]:bg-primary data-[state=active]:text-primary-foreground sm:px-2 sm:text-sm"
              >
                <Users className="h-4 w-4 mr-2" />
                Ուսանողներ ({pendingStudents.length})
              </TabsTrigger>
              <TabsTrigger 
                value="lecturers" 
                className="min-h-11 shrink-0 rounded-md px-3 text-xs text-muted-foreground data-[state=active]:bg-primary data-[state=active]:text-primary-foreground sm:px-2 sm:text-sm"
              >
                <GraduationCap className="h-4 w-4 mr-2" />
                Դասախոսներ ({pendingLecturers.length})
              </TabsTrigger>
            </TabsList>
            </div>
            
            <TabsContent value="students" className="mt-4">
              <UserApprovalTable
                users={pendingStudents}
                userType="student"
                onApprove={handleApprove}
                onReject={handleReject}
                actionLoading={actionLoading}
              />
            </TabsContent>
            
            <TabsContent value="lecturers" className="mt-4">
              <UserApprovalTable
                users={pendingLecturers}
                userType="lecturer"
                onApprove={handleApprove}
                onReject={handleReject}
                actionLoading={actionLoading}
              />
            </TabsContent>
          </Tabs>
        )}
      </CardContent>
    </Card>
  );
};
